// import { gsap, ScrollToPlugin } from "gsap/all";
// import jQuery from 'jquery'
// import Macy from 'macy'
import AOS from 'aos'
import Swiper, { Navigation, EffectFade, Autoplay } from 'swiper';
Swiper.use([Navigation, EffectFade, Autoplay]);
// gsap.registerPlugin(ScrollToPlugin);
import lazySizes from 'lazysizes';
lazySizes.cfg.lazyClass = 'lazyload';

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    AOS.init();
    
    var swpr = new Swiper(".swiper-testimonials", {
      modules: [Navigation],
      navigation: {
        nextEl: ".swiper-button-n",
        prevEl: ".swiper-button-p",
      },
      loop: true,
      slideActiveClass: "swiper-slide-active",
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0
    });
    
    var swprHiring = new Swiper(".swiper-hiring", {
      modules: [EffectFade, Autoplay],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    });

    const contactButtons = document.querySelectorAll('[data-contact]');
    contactButtons.forEach(button => {
      button.addEventListener('click', function(e){
        e.preventDefault();
        var addressValue = this.getAttribute('href');
        if(typeof gtag === 'function') {
          gtag('event', 'click', { event_category: 'contact', event_label: 'footer'});
        }
        if(typeof fbq === 'function') {
          fbq('track', 'Contact');
        }
        if(typeof twq === 'function') {
          twq('track', 'Lead');
        }
        setTimeout(() => {
          window.location.href = addressValue;
        }, 100);
      });
    });
    const applyButtons = document.querySelectorAll('[data-apply-now]');
    applyButtons.forEach(button => {
      button.addEventListener('click', function(e){
        e.preventDefault();
        var addressValue = this.getAttribute('href');
        if(typeof gtag === 'function') {
          gtag('event', 'click', { event_category: 'apply', event_label: 'apply now'});
        }
        if(typeof fbq === 'function') {
          fbq('track', 'SubmitApplication');
        }
        if(typeof twq === 'function') {
          twq('track', 'ViewContent');
        }
        setTimeout(() => {
          window.location.href = addressValue;
        }, 100);
      });
    });
    
  });
})();